import { createSlice } from '@reduxjs/toolkit';
import type { IAppConfigState } from './interfaces';
import { FetchAppConfigAsync } from './async.thunks';
import { initState } from './init.state';

export const AppConfigSlice = createSlice({
  name: 'appConfig',
  initialState: initState,
  reducers: {
    SetAppConfig: (state: IAppConfigState, action: any) => {
      return {
        ...state,
        calendar: {
          upperBound: action?.payload?.calendar?.upperBound || null,
        },
        source: action?.payload?.source || null,
        error: null,
      };
    },
    ClearAppConfig: () => {
      return initState;
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(FetchAppConfigAsync.pending, (_state: IAppConfigState) => ({
      ..._state,
      FetchAppConfigAsyncStatus: 'PENDING',
      error: null,
    }));

    builder.addCase(FetchAppConfigAsync.rejected, (_state: IAppConfigState, action: any) => ({
      ..._state,
      FetchAppConfigAsyncStatus: 'ERROR',
      error: action?.error?.message || 'Unable to fetch app config',
    }));

    builder.addCase(FetchAppConfigAsync.fulfilled, (_state: IAppConfigState, action: any) => ({
      ..._state,
      calendar: {
        upperBound: action?.payload?.calendar?.upperBound || null,
      },
      source: action?.payload?.source || null,
      FetchAppConfigAsyncStatus: 'SUCCESS',
      error: null,
      hydratedFromCache: false,
    }));
  },
});

export const { SetAppConfig, ClearAppConfig } = AppConfigSlice.actions;
export { FetchAppConfigAsync };

export const selectAppConfig = (state: any) => state?.appConfig || initState;
export const selectCalendarUpperBound = (state: any) =>
  state?.appConfig?.calendar?.upperBound || null;

export default AppConfigSlice.reducer;
